export default __webpack_public_path__ + "static/media/settings.852e49e9.svg";